import request from '@/utils/request3'
import store from '@/store'
import qs from 'qs'
const serviceName = store.state.serviceName.goodsSystem

// 获取货物分类
export function getGoodsClassList(data) {
    return request({
        url: serviceName + `/query_goods_class?classFlag=` + data.classFlag,
        method: 'get',
    })
}

// 新增货品分类
export function insertGoodsClass(data) {
    return request({
        url: serviceName + `/insert_goods_class`,
        method: 'post',
        data: data
    })
}

// 批量删除货物分类
export function deleteGoodsClass(data) {
    return request({
        url: serviceName + `/delete_goods_class`,
        method: 'post',
        data: data
    })
}

// 修改货品分类
export function updateGoodsClass(data) {
    return request({
        url: serviceName + `/update_goods_class`,
        method: 'post',
        data: data
    })
}

// 获取供应商列表
export function getSupplierList(data) {
    return request({
        url: serviceName + `/query_supplier_byPage`,
        method: 'post',
        data: data
    })
}

// 添加供应商
export function insertSupplier(data) {
    return request({
        url: serviceName + `/insert_supplier`,
        method: 'post',
        data: data
    })
}

// 修改供应商
export function updateSupplier(data) {
    return request({
        url: serviceName + `/update_supplier`,
        method: 'post',
        data: data
    })
}

// 删除供应商
export function deleteSupplier(data) {
    return request({
        url: serviceName + `/delete_supplier?id=`+data.id,
        method: 'get',
        data: data
    })
}

// 删除银行卡
export function deleteBank(data) {
    return request({
        url: serviceName + `/delete_bank?id=`+ data.id,
        method: 'get',
        data: data
    })
}

// 添加银行卡
export function addBank(data) {
    return request({
        url: serviceName + `/insert_bank`,
        method: 'post',
        data: data
    })
}

//查询当前登录用户的商机
export function getProjects(data) {
    return request({
        url: serviceName + `/work-order/get-projects`,
        method: 'get',
    })
}


// 查询货物列表
export function getGoodsByPage(data) {
    return request({
        url: serviceName + `/query_goods_byPage`,
        method: 'post',
        data: data
    })
}


// 新增货物
export function addGoods(data) {
    return request({
        url: serviceName + `/insert_goods`,
        method: 'post',
        data: data
    })
}

// 删除货物
export function deleteGoods(data) {
    return request({
        url: serviceName + `/delete_goods?id=`+data.id,
        method: 'get',
    })
}


// 修改货物
export function updateGoods(data) {
    return request({
        url: serviceName + `/update_goods`,
        method: 'post',
        data: data
    })
}

// 获取单位 列表
export function getUnits(data) {
    return request({
        url: serviceName + `/query_goods_unit`,
        method: 'get',
        data: data
    })
}